// extracted by mini-css-extract-plugin
export default {"Navbar":"MobileNavbar_Navbar__dHg1z","Icon":"MobileNavbar_Icon__y7BHl","Logo":"MobileNavbar_Logo__zUcTm"};